import clsx from "clsx";
import { useProjectOverview } from "@/projectOverview/useProjectOverview";

const ICON_SRC = "/static/icons/apple-touch-icon-180.png";

export function ProjectOverviewButton({
  auftragId,
  className,
  disabled,
  title = "Projektübersicht",
  onOpenOverride,
}: {
  auftragId: number | null | undefined;
  className?: string;
  disabled?: boolean;
  title?: string;
  /** Statt `useProjectOverview().open` (z. B. Multi-Window aus Rechnungsentwurf). */
  onOpenOverride?: (auftragId: number) => void;
}) {
  const { open } = useProjectOverview();
  const id = Number(auftragId);
  const canOpen = Number.isFinite(id) && id > 0 && !disabled;

  return (
    <button
      type="button"
      className={clsx(
        "inline-flex h-8 w-8 items-center justify-center rounded-md border border-separator bg-card text-label transition hover:bg-fill-tertiary disabled:opacity-40",
        className,
      )}
      disabled={!canOpen}
      title={title}
      aria-label={title}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        if (!canOpen) return;
        if (onOpenOverride) onOpenOverride(id);
        else open(id);
      }}
    >
      <img src={ICON_SRC} alt="" width={18} height={18} className="object-contain" decoding="async" />
    </button>
  );
}
